import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => {
        if (error instanceof ApiError && ['forbidden', 'not_authenticated', 'booking_not_found', 'tenant_not_found', 'rate_limited'].includes(error.code)) return false;
        return count < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});
